// extracted by mini-css-extract-plugin
export default {"ellipsis":"e47wrUfPedC5MZSWd2Hz","wrapper":"yS0Ud_cT8V8RK2YIHWB7","spin":"W8kI1aDdxqOW1q8bH7QJ"};